<template>
  <div class="group__radio">
    <div class="flex flex-wrap select-box">
      <template v-for="option in options">
        <label :key="option.title" class="w-full text-base font-normal md:w-1/2 md:pr-3">
          <input v-model="radioValue" :name="name" type="radio" :value="option.value">
          <span class="inline-block mr-2 radio"></span> {{ option.title }}
        </label>
      </template>
    </div>
  </div>
</template>

<script>
/**
 * @property {Array<RadioGroupOption>} options
 */
export default {
  name: "RadioGroup",
  props: {
    name: String,
    options: {
      type: Array,
      required: true,
    },
    value: {
      required: true,
    }
  },
  computed: {
    radioValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
}
</script>

<style scoped>

</style>